import { GameVars } from "./../GameVars";
import { GameConstants } from "../GameConstants";
import { AudioManager } from "./AudioManager";
import { RoomScene } from "../scenes/room/RoomScene";

export class GameManager {

    private static game: Phaser.Game;

    public static init(game: Phaser.Game): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAME_DISTRIBUTION) {
            GameManager.initGameDistributionSDK();
        }

        GameManager.game = game;
        GameManager.readGameData();
    }

    public static initGameDistributionSDK(): void {

        window["GD_OPTIONS"] = {
            "gameId": "8503312b1e3a4057bd77e17263eb5849",
            "onEvent": function(event: any): any {
                switch (event.name) {
                    case "SDK_GAME_START":
                        if (AudioManager.sound) {
                            AudioManager.sound.mute(GameVars.gameData.muted);
                        }
                        
                        if (GameVars.typeAd === "Enter Room Scene") {
                            GameManager.enterRoomScene();
                        } else if (GameVars.typeAd === "Enter HiLo") {
                            GameManager.enterHiLoScene();
                        } else if (GameVars.typeAd === "Enter Splash") {
                            GameManager.enterSplashScene();
                        }
                        break;
                    case "SDK_GAME_PAUSE":
                        if (AudioManager.sound) {
                            AudioManager.sound.mute(true);
                        }
                        break;
                    case "SDK_GDPR_TRACKING":
                        console.log("SDK_GDPR_TRACKING");
                        break;
                    case "SDK_GDPR_TARGETING":
                        console.log("SDK_GDPR_TARGETING");
                        break;
                    default:
                        break;
                }
            },
        };
        (function(d: any, s: any, id: any): any {
            var js: any, fjs: any = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://html5.api.gamedistribution.com/main.min.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "gamedistribution-jssdk"));
    }

    public static readGameData(): void {
        
        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
                function(gameData: string): void {

                    if (gameData) {
                        GameVars.gameData = JSON.parse(gameData);
                    } else {
                        GameVars.gameData = {
                            muted: false,
                            chips: 10000,
                            firstTime: true,
                            highLowWins: 0,
                            highLowConsecutiveWins: 0,
                            handsWins: 0,
                            eliminatedPlayers: 0
                        };
                    }
                    GameManager.startGame();
                }
        );
    }

    public static writeGameData(): void {
        
        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY, 
            GameVars.gameData,
            function(): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static onGameAssetsLoaded(): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_IZZYGAMES) {

            const domains = ["spiele-umsonst.de", "izzygames.com", "localhost", "127", "192", "footchinko.com"];
                
            if (GameVars.areValidDomains(domains)) {
                GameManager.correctUrl();
            }
            
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {

            const domains = ["funo.com", "yurk.com", "friv.com", "femo.com", "fabo.com", "friv.co.uk", "friv4school.com", "frivmath.com", "funomath.com", "localhost", "127", "192", "footchinko.com"];
                
            if (GameVars.areValidDomains(domains)) {
                GameManager.correctUrl();
            }
            
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_IZZYGAMES) {

            const domains = ["localhost", "127", "192", "footchinko.com"];
                
            if (GameVars.areValidDomains(domains)) {
                GameManager.correctUrl();
            }

        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {

            LaggedAPI.init("banana_pokerg_inints", "lagdevaF3001");

            const domains = ["lagged.com", "gamesbutler.com", "localhost", "127", "192", "footchinko.com"];
            
            if (GameVars.areValidDomains(domains)) {
                GameManager.correctUrl();
            } 
           
        } else {
            GameManager.correctUrl();
        }
    }

    public static correctUrl(): void {
        GameVars.botsInfo = GameManager.game.cache.json.get("bots");

        GameVars.winners = {};
        GameVars.points = {};
        GameVars.winnerCount = 0;

        let keys = Object.keys(GameVars.botsInfo);
        for (let i = 0; i < keys.length; i++) {
            GameVars.winners[keys[i]] = 0;
            GameVars.points[keys[i]] = 0;
        }
        
        AudioManager.init();

        GameManager.enterSplashScene();
        // GameManager.enterHiLoScene();
    }

    public static enterRoomScene(): void {

        GameVars.initialChips = GameVars.gameData.chips - GameConstants.ROOM_PRICE;
        GameVars.gameData.firstTime = false;
        GameManager.writeGameData();

        GameVars.currentScene.scene.start("RoomScene");
    }

    public static enterHiLoScene(): void {

        GameVars.currentScene.scene.start("HiLoScene");
    }

    public static enterSplashScene(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static finishGameLaggedAward(length: number) {

        var api_awards = [];

        if (length === 0) {
            api_awards.push("bananan_pokerg_vkma001");
        } else if (length === 1) {
            api_awards.push("bananan_pokerg_vkma002");
        } else if (length === 2) {
            api_awards.push("bananan_pokerg_vkma003");
        }

        LaggedAPI.Achievements.save(api_awards, function(response: any) {
            if (response.success) {
                console.log("achievement saved");
            } else {
                console.log(response.errormsg);
            }
        });
    }

    public static log(text: string, error?: Error): void {
        
        if (!GameConstants.VERBOSE) {
            return;
        }
        
        if (error) {
            console.error(text + ":",  error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {
        
        GameManager.game.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function): void {
        
        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {
        
        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
